import storage from 'store'
import { login, getInfo, logout } from '@/api/login'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { setToken } from '@/utils/auth'
import * as logistics from '@/api/logistics'
import * as common from '@/api/tool/common'

const user = {
  state: {
    token: '',
    name: '',
    welcome: '',
    avatar: '',
    isAdmin: false,
    roles: [],
    info: {},
    cityList: [],
    customDict: {}
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ADMIN: (state, admin) => {
      state.isAdmin = admin
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_INFO: (state, info) => {
      state.info = info
    },
    SET_PERMISSIONS: (state, permissions) => {
      state.permissions = permissions
    },
    SET_CITYS: (state, info) => {
      state.cityList = info
    },
    SET_DICT: (state, info) => {
      state.customDict = info
    }
  },

  actions: {
    // 登录
    Login ({ commit }, userInfo) {
      const username = userInfo.username.trim()
      const password = userInfo.password
      const userType = 'ADMIN'
      const loginType = 'PASSWORD'
      const smsCode = userInfo.code
      const uuid = userInfo.uuid
      return new Promise((resolve, reject) => {
        login(username, password, smsCode, uuid, userType, loginType).then(res => {
          window.console.log('登录成功', res)
          setToken(res.data.token)
          commit('SET_TOKEN', res)

          storage.set(ACCESS_TOKEN, res.data.token, 7 * 24 * 60 * 60 * 1000)
          // commit('SET_TOKEN', res.token)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息
    GetInfo ({ commit, state }) {
      return new Promise((resolve, reject) => {
        getInfo(state.token).then(res => {
          const user = res.data.user
          const avatar = user.avatar === '' ? require('@/assets/images/profile.jpg') : process.env.VUE_APP_BASE_API + user.avatar
          if (res.data.roles && res.data.roles.length > 0) { // 验证返回的roles是否是一个非空数组
            commit('SET_ROLES', res.data.roles)
            commit('SET_PERMISSIONS', res.data.permissions)
          } else {
            commit('SET_ROLES', ['ROLE_DEFAULT'])
          }
          commit('SET_NAME', user.userName)
          commit('SET_AVATAR', avatar)
          commit('SET_ADMIN', user.admin)
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 登出
    Logout ({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        }).finally(() => {
          commit('SET_TOKEN', '')
          commit('SET_ROLES', [])
          commit('SET_PERMISSIONS', [])
          storage.remove(ACCESS_TOKEN)
        })
      })
    },
    // 获取字典
    getDict({ commit, state }) {
      return new Promise((resolve, reject) => {
        common.getDict().then((res) => {
          if (res.success) {
            commit('SET_DICT', res.data)
          }
        })
      })
    },
    // 获取运费模板 使用的省市区
    getCity({ commit, state }) {
      return new Promise((resolve, reject) => {
        logistics.cityListTree().then((res) => {
          if (res.success) {
            /** 为城市数组增加前端需要的isShow */
            res.data.forEach((item, index) => {
              item.isShow = true
              item.disabled = false
              item.cityNum = 0
              item.children.forEach((item1, index1) => {
                item1.isShow = true
                item1.disabled = false
                item.cityNum += 1
              })
            })
            commit('SET_CITYS', res.data)
          }
        })
      })
    }
  }
}

export default user
